// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_input__wmxoC {
  box-sizing: border-box;
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border-radius: 12px;
  border: 1.5px solid;
  transition: border 0.3s, box-shadow 0.3s;
  background: transparent;
  outline: none;
  color: #fff;
}

.Input_input__wmxoC::placeholder {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
}

.Input_input__wmxoC:focus {
  border-color: #8a62e6;
  box-shadow: 0 0 8px rgba(138, 98, 230, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Input/Input.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C","sourcesContent":[".input {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 16px;\n  border-radius: 12px;\n  border: 1.5px solid;\n  transition: border 0.3s, box-shadow 0.3s;\n  background: transparent;\n  outline: none;\n  color: #fff;\n}\n\n.input::placeholder {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.input:focus {\n  border-color: #8a62e6;\n  box-shadow: 0 0 8px rgba(138, 98, 230, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `Input_input__wmxoC`
};
export default ___CSS_LOADER_EXPORT___;
